import React, { useEffect, useState } from 'react';
import { apiGet, apiPatch } from '../../utils/api';
import { SportIcon, SPORT_ICON_MAP } from '../../utils/sportIcons';
import '../../styles/sport-icons.scss';

interface SportItem {
  id: number;
  name: string;
  icon: string | null;
}

const SportIcons: React.FC = () => {
  const [sports, setSports] = useState<SportItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState<number | null>(null);
  const [openPicker, setOpenPicker] = useState<number | null>(null);

  useEffect(() => {
    apiGet<SportItem[]>('/admin/sports')
      .then(setSports)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = async (sportId: number, iconName: string | null) => {
    setSaving(sportId);
    try {
      const updated = await apiPatch<SportItem>(`/admin/sports/${sportId}/icon`, { icon: iconName });
      setSports(prev => prev.map(s => s.id === updated.id ? updated : s));
      setOpenPicker(null);
    } catch (e) {
      console.error(e);
    } finally {
      setSaving(null);
    }
  };

  if (loading) return <div className="sport-icons sport-icons--loading">Loading…</div>;

  return (
    <div className="sport-icons">
      <h1 className="sport-icons__title">Sport Icons</h1>

      <div className="sport-icons__list">
        {sports.map(sport => (
          <div key={sport.id} className="sport-icons__row">
            <div className="sport-icons__sport-name">{sport.name}</div>

            <div className="sport-icons__current">
              {sport.icon ? (
                <>
                  <SportIcon name={sport.icon} size={20} />
                  <span className="sport-icons__icon-label">{sport.icon}</span>
                </>
              ) : (
                <span className="sport-icons__no-icon">—</span>
              )}
            </div>

            <button
              className="sport-icons__pick-btn"
              onClick={() => setOpenPicker(openPicker === sport.id ? null : sport.id)}
              disabled={saving === sport.id}
            >
              {saving === sport.id ? 'Saving…' : 'Change'}
            </button>

            {openPicker === sport.id && (
              <div className="sport-icons__picker">
                <button
                  className="sport-icons__picker-item sport-icons__picker-item--none"
                  onClick={() => handleSelect(sport.id, null)}
                >
                  None
                </button>
                {Object.keys(SPORT_ICON_MAP).map(iconName => (
                  <button
                    key={iconName}
                    className={`sport-icons__picker-item${sport.icon === iconName ? ' sport-icons__picker-item--active' : ''}`}
                    onClick={() => handleSelect(sport.id, iconName)}
                    title={iconName}
                  >
                    <SportIcon name={iconName} size={22} />
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SportIcons;
